import * as React from 'react';

function SvgAttach(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 26" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M6.26 26a6.19 6.19 0 01-4.4-1.91 6.59 6.59 0 01.27-9.44L14.84 1.56a4.53 4.53 0 014.5-1.41 4.69 4.69 0 013.22 3.31A4.87 4.87 0 0121.2 8.1L9 20.62a3.75 3.75 0 01-2.27 1.22 2.43 2.43 0 01-2-.71c-.94-1-1.08-2.8.49-4.42l8.55-8.8a.88.88 0 011.27 0 1 1 0 010 1.31L6.48 18c-.73.76-.8 1.48-.49 1.81a.69.69 0 00.59.17 2 2 0 001.19-.69l12.16-12.5a3 3 0 00.9-2.79 2.84 2.84 0 00-1.95-2 2.79 2.79 0 00-2.77.93C12.49 6.61 5.21 14.09 3.4 16a4.71 4.71 0 00-.27 6.82c1.53 1.58 4.25 2.16 6.62-.28L22.47 9.41a.88.88 0 011.27 0 1 1 0 010 1.31L11 23.81A6.62 6.62 0 016.26 26z" />
    </svg>
  );
}

const MemoSvgAttach = React.memo(SvgAttach);
export default MemoSvgAttach;
